import React from 'react';
import './News.css'; 
import { Heading } from '../../../components';
import { images, titles } from '../../../constants';
import { news, drawingsArticleData } from '../../../constants'; 

import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';

import 'swiper/css';
import 'swiper/css/pagination';

const fallbackImages = [
    images.news1,
    images.news2,
    images.news3,
    images.news4,
    images.news5,
    images.news6,
];

const getFallbackImage = (itemId) => fallbackImages[(itemId - 1) % fallbackImages.length];

const News = () => {
    const { t } = useTranslation();

    return (
        <section className='news-section' id='aktualnosci'>
            <Heading title={t(titles.titleNews)} subTitle={t(titles.subTitleNews)} />

            <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                loop={true}
                pagination={{ clickable: true }}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                breakpoints={{
                    450: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1100: { slidesPerView: 3 },
                }}
            >
                {news.map((item) => (
                    <SwiperSlide key={item.id}>
                        <div className='news-card'>
                            <div className='news-image'>
                                <img 
                                    src={
                                        item.image 
                                            ? item.image 
                                            : `https://api.microlink.io/?url=${encodeURIComponent(item.link)}&embed=image.url`
                                    }
                                    alt={t(item.title)} 
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = getFallbackImage(item.id);
                                    }}
                                />
                                <span className='news-source'>{t(item.source)}</span>
                            </div>
                            <div className='news-body'>
                                <h4>{t(item.title)}</h4>
                                <p>{t(item.content)}</p>
                                <a
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className='news-link'
                                >
                                    Czytaj artykuł →
                                </a>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Dolna sekcja z tlumaczeniem przez t() */}
            <div className='news-columns-layout'>
                <div className='news-side-image-box'>
                    <img 
                        src={images.news_new} 
                        alt={t(drawingsArticleData.title)} 
                        className="news-side-image"
                    />
                </div>

                <article className='news-side-text-box'>
                    <span className='news-category-tag'>
                        {t(drawingsArticleData.badge)}
                    </span>
                    <h3 className='news-article-heading'>
                        {t(drawingsArticleData.title)}
                    </h3>
                    
                    <div className='news-article-paragraphs'>
                        <p>{t(drawingsArticleData.p1)}</p>
                        <p>{t(drawingsArticleData.p2)}</p>
                        <p>{t(drawingsArticleData.p3)}</p>
                        <p>{t(drawingsArticleData.p4)}</p>
                        <p>{t(drawingsArticleData.p5)}</p>
                        <p className='news-article-quote'>
                            {t(drawingsArticleData.quote)}
                        </p>
                    </div>
                </article>
            </div>
        </section>
    );
};

export default News;